document.addEventListener('DOMContentLoaded', function () {
    const bullets = document.querySelectorAll('.collection-slider__bullet-title');
    const swipers = document.querySelectorAll('.product-slider__swiper');

    // Initially activate the first bullet and swiper
    bullets[0].classList.add('collection-slider__bullet-title-active');
    swipers[0].style.display = 'block';

    // Add event listeners to each bullet
    bullets.forEach(function (bullet) {
        bullet.addEventListener('click', function () {
            // Remove active class from all bullets
            bullets.forEach(function (b) {
                b.classList.remove('collection-slider__bullet-title-active');
            });

            // Hide all swipers
            swipers.forEach(function (swiper) {
                swiper.style.display = 'none';
            });

            // Add active class to the clicked bullet
            bullet.classList.add('collection-slider__bullet-title-active');

            // Find the related swiper based on the data-block-id and display it
            const blockId = bullet.getAttribute('data-block-id');
            const relatedSwiper = document.getElementById('swiper-' + blockId);
            if (relatedSwiper) {
                relatedSwiper.style.display = 'block';
            }
        });
    });

    // Initialize Swiper for each .product-slider__swiper
    swipers.forEach(function (swiper) {

        const swiperInstance = new Swiper(swiper, {
            loop: false,
            spaceBetween: 6,
            slidesPerView: 1.3,
            centeredSlides: false,
            preloadImages: true,
            updateOnImagesReady: true,
            watchSlidesProgress: true,
            pagination: {
                el: swiper.querySelector('.swiper-pagination.product-slider__swiper-pagination'),
                type: 'progressbar',
            },
            grabCursor: true,
            freeMode: true,
            mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
            },
            watchOverflow: true,
            breakpoints: {
                500: {
                    loop: false,
                    slidesPerView: 1.5,
                    centeredSlides: false,
                    spaceBetween: 10,
                },
                600: {
                    loop: false,
                    slidesPerView: 1.9,
                    centeredSlides: false,
                    spaceBetween: 10,
                },
                800: {
                    loop: false,
                    slidesPerView: 2.25,
                    centeredSlides: false,
                    spaceBetween: 10,
                },
                900: {
                    loop: false,
                    slidesPerView: 2.75,
                    centeredSlides: false,
                    spaceBetween: 8,
                },
                1100: {
                    loop: false,
                    slidesPerView: 3.25,
                    centeredSlides: false,
                    spaceBetween: 8,
                },
                1200: {
                    loop: false,
                    slidesPerView: 4,
                    centeredSlides: false,
                    spaceBetween: 8,
                },
                1600: {
                    loop: false,
                    slidesPerView: 4.9,
                    centeredSlides: false,
                    spaceBetween: 8,
                },
            },
        });
    });
});
